module.exports = "/assets/9975623c69ec7dba5639e5c7934d1bc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BA.png
// module id = 2352
// module chunks = 0